import axios from "axios";

// Dynamically determine the API base URL.
// If running in a browser (remote device), it uses the current hostname.
// If running in Electron (file://), it defaults to localhost.
const getAPIHost = () => {
  // 1. Check for manual override in localStorage (useful for remote hosting)
  const savedURL = localStorage.getItem("api_base_url");
  if (savedURL) {
    try {
      const url = new URL(savedURL);
      return { host: url.host, protocol: url.protocol };
    } catch (e) {
      console.error("Invalid saved API URL:", savedURL);
    }
  }

  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  // 2. Handle VS Code Dev Tunnels (often prefixes port to hostname)
  if (hostname && hostname.includes('devtunnels.ms') && hostname.includes('-3000')) {
    return {
      host: hostname.replace('-3000', '-5000'),
      protocol: protocol // Tunnels usually handle https -> http mapping
    };
  }

  // 3. Handle connection over IP or other hostname
  if (hostname && hostname !== 'localhost' && hostname !== '127.0.0.1' && hostname !== 'null') {
    return { host: hostname, protocol: protocol };
  }
  
  // 4. Default for Electron or local development
  return { host: "localhost", protocol: "http:" }; 
};


const { host: HOST, protocol: PROTOCOL } = getAPIHost();
const PORT = HOST.includes('devtunnels.ms') ? '' : ':5000'; // Tunnels usually don't need port in URL if port-prefixed
const BASE_URL = `${PROTOCOL}//${HOST}${PORT}/api/`;

console.log(`[API] Connecting to: ${BASE_URL}`);

const api = axios.create({
  baseURL: BASE_URL,
});

// Attach token and normalize URL
api.interceptors.request.use((config) => {
  // Ensure the URL is relative to baseURL by stripping leading slash
  if (config.url && config.url.startsWith('/') && !config.url.startsWith('http')) {
    config.url = config.url.substring(1);
  }

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// Normalize responses and errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const normalized = {
      status: error?.response?.status || 0,
      message:
        error?.response?.data?.message ||
        error?.message ||
        "An unexpected error occurred",
      data: error?.response?.data,
    };
    return Promise.reject(normalized);
  }
);

export default api;
